import { AssetSvg as e } from "../AssetSvg.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/assets/artwork/StatusToDoIcon20Artwork.tsx
var n = (n) => /* @__PURE__ */ t(e, {
	viewBox: "0 0 20 20",
	fill: "none",
	...n,
	children: /* @__PURE__ */ t("circle", {
		cx: 10,
		cy: 10,
		r: 7.09375,
		stroke: "#8F8B85",
		strokeWidth: 1.5625
	})
});
//#endregion
export { n as StatusToDoIcon20Artwork };
